import React from 'react';
import { Outlet } from 'react-router';

function without(){
    return (
        <Outlet/>
    );
}
export default without;